import { createTwoFilesPatch } from 'diff';

/**
 * Stripped unified diff hunks only (matches chef/app/utils/diff.ts).
 * Prefer diff over full duplicate body when strictly smaller — caller caps size.
 */
export function strippedUnifiedDiff(
  relativePath: string,
  baseline: string,
  current: string,
): string | undefined {
  let unifiedDiff = createTwoFilesPatch(relativePath, relativePath, baseline, current);
  const patchHeaderEnd = `--- ${relativePath}\n+++ ${relativePath}\n`;
  const headerEndIndex = unifiedDiff.indexOf(patchHeaderEnd);
  if (headerEndIndex >= 0) {
    unifiedDiff = unifiedDiff.slice(headerEndIndex + patchHeaderEnd.length);
  }
  if (!unifiedDiff.trim()) return undefined;

  /** If unified diff grows past current body, snapshots already carry payload. */
  if (unifiedDiff.length >= current.length) return undefined;

  return unifiedDiff;
}
